<template>
  <div class="WMap">
    <CallHelpTel />
    <div class="container">
      <div class="txt_group">
        <div class="txt_item">
          <p>
            本網站依無障礙網頁設計原則建置，網站的主要內容分為三大區塊：<br />
            1. 上方功能區塊<br />
            2. 中央內容區塊<br />
            3. 下方選單連結區塊<br />
          </p>
          <p class="accesskey">
            本網站的快速鍵﹝Accesskey﹞設定如下：<br />
            Alt+U：選單連結區塊，此區塊列有本網站主要連結。<br />
            Alt+C：中央內容區塊，為本頁主要內容區。<br />
            Alt+Z：頁尾網站資訊。<br />
            如果您的瀏覽器是Firefox，快速鍵的使用方法是 Shift+Alt+(快速鍵字母)。
          </p>
        </div>
      </div>
      <div class="list">
        <ul class="list_wrap">
          <li class="list_item">
            <div class="list_title">
              <h3 :style="{ fontSize: fontSize.h4 + 'em' }">1.中心介紹</h3>
            </div>
            <ul class="list_inside">
              <li>
                <router-link
                  :style="{ fontSize: fontSize.p + 'em' }"
                  to="/About"
                  title="國人海外就業資源中心"
                  >1-1&nbsp;國人海外就業資源中心</router-link
                >
              </li>
            </ul>
          </li>

          <li class="list_item">
            <div class="list_title">
              <h3 :style="{ fontSize: fontSize.h4 + 'em' }">2.海外就業國家</h3>
            </div>
            <ul class="list_inside country_list">
              <template v-for="(country, j) in countries" :key="j">
                <li href="#" v-for="(coun, i) in country.countries" :key="i">
                  <a
                    :style="{ fontSize: fontSize.p + 'em' }"
                    :href="`/${coun.countryId}`"
                    :title="coun.countryName"
                  >
                    2-{{ i + 1 }}&nbsp;{{ coun.countryName }}
                  </a>
                </li>
              </template>
            </ul>
          </li>
          <li class="list_item">
            <div class="list_title">
              <h3 :style="{ fontSize: fontSize.h4 + 'em' }">3.海外就業分享</h3>
            </div>
            <ul class="list_inside">
              <li>
                <router-link
                  :style="{ fontSize: fontSize.p + 'em' }"
                  to="/video"
                  title="影音專區"
                  >3-1&nbsp;影音專區</router-link
                >
              </li>
              <li>
                <router-link
                  :style="{ fontSize: fontSize.p + 'em' }"
                  to="/article"
                  title="專家建議"
                  >3-2&nbsp;專家建議</router-link
                >
              </li>
              <li>
                <router-link
                  :style="{ fontSize: fontSize.p + 'em' }"
                  to="/submit"
                  title="達人投稿"
                  >3-3&nbsp;達人投稿</router-link
                >
              </li>
            </ul>
          </li>
          <li class="list_item">
            <div class="list_title">
              <h3 :style="{ fontSize: fontSize.h4 + 'em' }">4.海外就業指南</h3>
            </div>
            <ul class="list_inside">
              <li v-for="(message, i) in guides" :key="message.pageId">
                <a
                  :style="{ fontSize: fontSize.p + 'em' }"
                  :href="message.pageContent"
                  :title="'[另開新視窗]' + message.nodeName"
                  target="_blank"
                  >4-{{ i + 1 }}&nbsp;{{ message.pageTitle }}
                </a>
              </li>
            </ul>
          </li>
          <li class="list_item">
            <div class="list_title">
              <h3 :style="{ fontSize: fontSize.h4 + 'em' }">5.海外返國專區</h3>
            </div>
            <ul class="list_inside">
              <li>
                <router-link
                  :style="{ fontSize: fontSize.p + 'em' }"
                  to="/Return_employment"
                  title="返國資訊"
                  >5-1&nbsp;返國資訊</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, inject } from "vue";
import { apiCountry, apiGuide, apiTour } from "@/api/api.js";
import CallHelpTel from "../components/Home/CallHelpTel.vue";

export default {
  components: {
    CallHelpTel,
  },
  setup() {
    let fontSize = inject("fontSize");
    const mapList = reactive([]);
    const guides = reactive([]);
    const countries = reactive([]);
    apiGuide()
      .then((res) => {
        res.data.forEach((i) => {
          guides.push(i);
        });
      })
      .catch((err) => {
        console.log(err);
      });
    apiTour()
      .then((res) => {
        mapList.push(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    apiCountry()
      .then(function (res) {
        res.data.areas.forEach((i) => {
          countries.push(i);
        });
      })
      .catch(function (res) {
        console.log(res);
      });

    return {
      countries,
      mapList,
      guides,
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.txt_group {
  margin: 40px 0;
  text-align: left;
  @include xs {
    padding-left: 0;
  }
}
.txt_item {
  padding-bottom: 20px;
  .content {
    padding-left: 15px;
    margin: 0px 0 10px 0;
    color: $black_color;
  }
  .accesskey {
    margin-top: 24px;
  }
}

.list {
  margin: 50px 0 50px;
  .list_wrap {
    @include flex_center();
    align-items: flex-start;
    justify-content: space-between;
    @include xxl {
      flex-wrap: wrap;
    }
    .list_item {
      @include lg {
        margin-bottom: 20px;
      }
      @include md {
        margin-bottom: 20px;
        align-items: stretch;
      }
      @include sm {
        width: 100%;
        align-items: stretch;
      }
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .list_title {
        border-bottom: 1px solid $main_color;
        padding: 8px;
        width: 240px;
        @include lg {
          border: none;
        }
        @include sm {
          width: 100%;
        }
      }
    }
    .list_inside {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 10px;
      width: 220px;

      a {
        &:hover {
          text-decoration: underline;
        }
      }
      &.country_list {
        flex-wrap: wrap;
        height: 290px;
        transform: translateX(20px);
        li {
          margin-right: 20px;
          a {
            display: inline-block;
            text-align: left;
          }
        }
      }
      @include xs {
        text-align: left;
        margin: 10px auto;
      }
    }
    h3 {
      font-family: "Noto_Medium";
      color: $main_color;
      border: 2px dotted $main_color;
      padding: 5px 30px;
      @include xl {
        font-size: 1.1em;
        padding: 5px 10px;
      }
      @include sm {
        width: 100%;
      }
    }
    a {
      text-align: left;
    }
  }
}
</style>
